import React, { useState, useEffect } from 'react';
import ServiceCard from './ServiceCard';
import { useTourismData } from '../../context/TourismContext';

function ServiceInner() {
    const [services, setServices] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const { fetchServices, fetchFeaturedServices } = useTourismData();

    useEffect(() => {
        fetchServicesData();
    }, []);

    const fetchServicesData = async () => {
        try {
            setLoading(true);
            
            // Try to fetch featured services first
            let servicesData = [];
            try {
                const featuredData = await fetchFeaturedServices();
                if (featuredData && featuredData.results && featuredData.results.length > 0) {
                    servicesData = featuredData.results;
                } else if (featuredData && Array.isArray(featuredData) && featuredData.length > 0) {
                    servicesData = featuredData;
                }
            } catch (featuredError) {
                console.log('No featured services, trying all services');
            }
            
            // If no featured services, get all services
            if (servicesData.length === 0) {
                const allServicesData = await fetchServices();
                if (allServicesData && allServicesData.results) {
                    servicesData = allServicesData.results;
                } else if (allServicesData && Array.isArray(allServicesData)) {
                    servicesData = allServicesData;
                }
            }
            
            if (servicesData.length > 0) {
                setServices(servicesData);
            } else {
                // Fallback to demo data if API fails
                setServices([
                    {
                        id: 1,
                        name: "Photo Shoot",
                        main_image: "/assets/img/destination/destination_4_1.jpg",
                        service_type: "guide",
                        short_description: "Professional photography services for your travel memories",
                        price: "25.00",
                        duration: "2 hours"
                    },
                    {
                        id: 2,
                        name: "Tour Guide",
                        main_image: "/assets/img/destination/destination_4_2.jpg",
                        service_type: "guide",
                        short_description: "Expert local guides for authentic travel experiences",
                        price: "50.00",
                        duration: "Full day"
                    },
                    {
                        id: 3,
                        name: "Equipment Rental",
                        main_image: "/assets/img/destination/destination_4_3.jpg",
                        service_type: "equipment",
                        short_description: "High-quality equipment for adventure activities",
                        price: "15.00",
                        duration: "Per day"
                    },
                    {
                        id: 4,
                        name: "Kayaking",
                        main_image: "/assets/img/destination/destination_4_4.jpg",
                        service_type: "equipment",
                        short_description: "Kayak rental and guided water adventures",
                        price: "35.00",
                        duration: "4 hours"
                    },
                    {
                        id: 5,
                        name: "Safe Flight",
                        main_image: "/assets/img/destination/destination_4_5.jpg",
                        service_type: "transport",
                        short_description: "Reliable and safe flight booking services",
                        price: "150.00",
                        duration: "Per trip"
                    },
                    {
                        id: 6,
                        name: "Entertainment",
                        main_image: "/assets/img/destination/destination_4_6.jpg",
                        service_type: "other",
                        short_description: "Cultural entertainment and local experiences",
                        price: "40.00",
                        duration: "3 hours"
                    },
                    {
                        id: 7,
                        name: "Delicious Food",
                        main_image: "/assets/img/destination/destination_4_7.jpg",
                        service_type: "other",
                        short_description: "Authentic local cuisine and food tours",
                        price: "30.00",
                        duration: "2 hours"
                    },
                    {
                        id: 8,
                        name: "Travel Insurance",
                        main_image: "/assets/img/destination/destination_4_8.jpg",
                        service_type: "insurance",
                        short_description: "Comprehensive travel insurance coverage",
                        price: "25.00",
                        duration: "Per trip"
                    }
                ]);
            }
            setError(null);
        } catch (err) {
            console.error('Error fetching services:', err);
            setError('Failed to load services');
            // Show demo data on error
            setServices([
                {
                    id: 1,
                    name: "Photo Shoot",
                    main_image: "/assets/img/destination/destination_4_1.jpg",
                    service_type: "guide",
                    short_description: "Professional photography services for your travel memories",
                    price: "25.00",
                    duration: "2 hours"
                },
                {
                    id: 2,
                    name: "Tour Guide",
                    main_image: "/assets/img/destination/destination_4_2.jpg",
                    service_type: "guide",
                    short_description: "Expert local guides for authentic travel experiences",
                    price: "50.00",
                    duration: "Full day"
                },
                {
                    id: 3,
                    name: "Equipment Rental",
                    main_image: "/assets/img/destination/destination_4_3.jpg",
                    service_type: "equipment",
                    short_description: "High-quality equipment for adventure activities",
                    price: "15.00",
                    duration: "Per day"
                },
                {
                    id: 4,
                    name: "Kayaking",
                    main_image: "/assets/img/destination/destination_4_4.jpg",
                    service_type: "equipment",
                    short_description: "Kayak rental and guided water adventures",
                    price: "35.00",
                    duration: "4 hours"
                },
                {
                    id: 5,
                    name: "Safe Flight",
                    main_image: "/assets/img/destination/destination_4_5.jpg",
                    service_type: "transport",
                    short_description: "Reliable and safe flight booking services",
                    price: "150.00",
                    duration: "Per trip"
                },
                {
                    id: 6,
                    name: "Entertainment",
                    main_image: "/assets/img/destination/destination_4_6.jpg",
                    service_type: "other",
                    short_description: "Cultural entertainment and local experiences",
                    price: "40.00",
                    duration: "3 hours"
                },
                {
                    id: 7,
                    name: "Delicious Food",
                    main_image: "/assets/img/destination/destination_4_7.jpg",
                    service_type: "other",
                    short_description: "Authentic local cuisine and food tours",
                    price: "30.00",
                    duration: "2 hours"
                },
                {
                    id: 8,
                    name: "Travel Insurance",
                    main_image: "/assets/img/destination/destination_4_8.jpg",
                    service_type: "insurance",
                    short_description: "Comprehensive travel insurance coverage",
                    price: "25.00",
                    duration: "Per trip"
                }
            ]);
        } finally {
            setLoading(false);
        }
    };

    // Function to get proper image URL
    const getImageUrl = (imageUrl) => {
        if (!imageUrl) return '/assets/img/destination/destination_4_1.jpg';
        
        // If it's already a complete path starting with /assets/, use it directly
        if (imageUrl.startsWith('/assets/')) {
            return imageUrl;
        }
        
        // If it's a full URL (starts with http/https), use it directly
        if (imageUrl.startsWith('http://') || imageUrl.startsWith('https://')) {
            return imageUrl;
        }
        
        // If it starts with /media/, use it directly (Django media URL)
        if (imageUrl.startsWith('/media/')) {
            return imageUrl;
        }
        
        // Otherwise, assume it's a filename and prepend assets path
        return `/assets/img/destination/${imageUrl}`;
    };

    // Format service data for ServiceCard
    const formatServiceData = (service) => ({
        id: service.id,
        image: getImageUrl(service.main_image),
        title: service.name,
        item: service.duration || `$${service.price}`,
        serviceType: service.service_type,
        description: service.short_description,
        price: service.price
    });

    if (loading) {
        return (
            <section className="position-relative overflow-hidden space" id="destination-sec">
                <div className="container">
                    <div className="text-center py-5">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading services...</span>
                        </div>
                        <p className="mt-3 text-muted">Loading our amazing services...</p>
                    </div>
                </div>
            </section>
        );
    }

    return (
        <section className="position-relative overflow-hidden space" id="destination-sec">
            <div className="container shape-mockup-wrap">
                {error && (
                    <div className="alert alert-warning text-center mb-4">
                        <i className="fas fa-exclamation-triangle me-2"></i>
                        {error} - Showing demo content
                    </div>
                )}
                
                <div className="row justify-content-center mb-5">
                    <div className="col-lg-8 text-center">
                        <h2 className="sec-title h1 mb-3">Our Premium Services</h2>
                        <p className="sec-text mb-0">
                            Discover our comprehensive range of travel services designed to make your journey unforgettable. 
                            From professional guides to equipment rental, we have everything you need.
                        </p>
                    </div>
                </div>

                <div className="row gy-4 gx-4">
                    {services.length > 0 ? (
                        services.map((service) => (
                            <div key={service.id} className="col-xl-3 col-lg-4 col-md-6">
                                <ServiceCard
                                    serviceID={service.id}
                                    serviceImage={formatServiceData(service).image}
                                    serviceTitle={formatServiceData(service).title}
                                    serviceItem={formatServiceData(service).item}
                                    serviceType={formatServiceData(service).serviceType}
                                    serviceDescription={formatServiceData(service).description}
                                    servicePrice={formatServiceData(service).price}
                                />
                            </div>
                        ))
                    ) : (
                        <div className="col-12 text-center py-5">
                            <div className="alert alert-info">
                                <h4>No Services Available</h4>
                                <p className="mb-0">Please check back later or contact us for more information.</p>
                            </div>
                        </div>
                    )}
                </div>

                {/* Shapes */}
                <div className="shape-mockup shape1 d-none d-xxl-block" style={{ bottom: "17%", right: "-9%" }}>
                    <img src="/assets/img/shape/shape_1.png" alt="shape" />
                </div>
                <div className="shape-mockup shape2 d-none d-xl-block" style={{ bottom: "8%", right: "-8%" }}>
                    <img src="/assets/img/shape/shape_2.png" alt="shape" />
                </div>
                <div className="shape-mockup shape3 d-none d-xxl-block" style={{ bottom: "15%", right: "-4%" }}>
                    <img src="/assets/img/shape/shape_3.png" alt="shape" />
                </div>
            </div>
        </section>
    );
}

export default ServiceInner;
